import { Box, Typography, styled, Stack, Tabs, Tab } from '@mui/material';
import { useState } from 'react';

const TableText = styled(Typography)(({ theme }) => ({
  fontSize: '13px',
  fontWeight: 500,
  color: '#E0E0E0',
}));

const CustomTable = ({ children, customStyle, ...others }) => (
  <Box
    component="table"
    {...others}
    sx={{
      width: '100%',
      backgroundColor: 'rgba(255, 255, 255, 0.015)',
      borderRadius: '8px',
      tableLayout: 'fixed',
      '& td, & th': {
        borderBottom: '1px solid rgba(255, 255, 255, 0.08)',
      },
      ...customStyle,
    }}
  >
    {children}
  </Box>
);

const CustomTH = ({ children, sx, ...others }) => (
  <Box
    component={'th'}
    {...others}
    sx={{
      textAlign: 'start',
      whiteSpace: 'nowrap',
      ...sx,
    }}
  >
    {children}
  </Box>
);

const CustomTD = ({ children, sx, ...others }) => (
  <Box
    component={'td'}
    {...others}
    sx={{
      whiteSpace: 'nowrap',
      ...sx,
    }}
  >
    {children}
  </Box>
);

const TabStyled = styled(Tab)(({ theme }) => ({
  margin: '0 !important',
  minWidth: 'unset',
  zIndex: 1,
  minHeight: 'unset',
  maxHeight: 'unset',
  height: '30px',
}));

// const LiveText = styled(Typography)(({ theme }) => ({
//   fontSize: 12,
//   color: '#008CFF',
//   fontWeight: 500,
//   flexGrow: 1,
//   textAlign: 'start',
// }));

// const LiveBox = () => (
//   <div
//     style={{
//       marginLeft: '4px',
//       margin: 'auto',
//       width: '10px',
//       height: '10px',
//       backgroundColor: '#fff',
//       borderRadius: '50%',
//     }}
//   />
// );

const LiveTransactionStatus = ({ transactionStats, currencyCode, translate }) => {
  const [tabIndex, setTabIndex] = useState(0);
  return (
    <Box sx={{ mt: 1 }}>
      <Tabs
        value={tabIndex}
        onChange={(e, newValue) => setTabIndex(newValue)}
        TabIndicatorProps={{
          style: {
            height: '100%',
            zIndex: 0,
            background: 'linear-gradient(190deg, rgb(199, 0, 0), rgb(216, 38, 19))',
          },
        }}
        textColor="inherit"
        variant="fullWidth"
        sx={{
          background: 'linear-gradient(to top, rgb(44, 7, 7), rgb(89, 38, 38))',
          borderRadius: '8px',
          minHeight: 'unset',
          mb: 1,
        }}
      >
        <TabStyled label={translate('deposit')} />
        <TabStyled label={translate('withdraw')} />
      </Tabs>

      <Box sx={{ background: 'rgb(37, 2, 2)' }}>
        <CustomTable>
          {tabIndex === 0 ? (
            <tr>
              <CustomTH sx={{ width: '50%' }}>
                <TableText sx={{ fontWeight: 600 }}>{translate('username')}</TableText>
              </CustomTH>
              <CustomTH sx={{ width: '50%' }}>
                <TableText sx={{ fontWeight: 600 }}>{translate('amount')}</TableText>
              </CustomTH>
            </tr>
          ) : (
            <tr>
              <CustomTH>
                <TableText sx={{ fontWeight: 600 }}>{translate('username')}</TableText>
              </CustomTH>
              <CustomTH>
                <TableText sx={{ fontWeight: 600 }}>{translate('amount')}</TableText>
              </CustomTH>
              <CustomTH>
                <TableText sx={{ fontWeight: 600 }}>{translate('game_name')}</TableText>
              </CustomTH>
            </tr>
          )}
        </CustomTable>
      </Box>

      <CustomTable customStyle={{ borderTopWidth: '1px', borderRadius: '8px' }}>
        <tbody>
          {tabIndex === 0 &&
            transactionStats?.deposits?.map((deposit, index) => (
              <tr key={`deposit-${index}`}>
                <CustomTD sx={{ width: '50%' }}>
                  <TableText>
                    {deposit.username.slice(0, 2)}***{deposit.username.slice(-2)}
                  </TableText>
                </CustomTD>
                <CustomTD sx={{ width: '50%' }}>
                  <TableText sx={{ color: '#FF3300' }}>
                    {currencyCode} {deposit.amount}
                  </TableText>
                </CustomTD>
              </tr>
            ))}
          {tabIndex === 1 &&
            transactionStats?.withdraws?.map((withdraw, index) => (
              <tr key={`withdraw-${index}`}>
                <CustomTD>
                  <TableText>
                    {withdraw.username.slice(0, 2)}***{withdraw.username.slice(-2)}
                  </TableText>
                </CustomTD>
                <CustomTD>
                  <TableText sx={{ color: '#FF3300' }}>
                    {currencyCode} {withdraw.amount}
                  </TableText>
                </CustomTD>
                <CustomTD>
                  <TableText>{withdraw.company_name}</TableText>
                </CustomTD>
              </tr>
            ))}
        </tbody>
      </CustomTable>
    </Box>
  );
};

export default LiveTransactionStatus;
